import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { SxProps, Theme, Tooltip } from "@mui/material";
import { TooltipProps } from "@mui/material/Tooltip";
import { CSSProperties, ReactElement, ReactNode, cloneElement } from "react";

type Placement =
  | "bottom-end"
  | "bottom-start"
  | "bottom"
  | "left-end"
  | "left-start"
  | "left"
  | "right-end"
  | "right-start"
  | "right"
  | "top-end"
  | "top-start"
  | "top";

type Variant = "primary" | "warning" | "error" | "text";

const variantSx: Record<Variant, SxProps<Theme>> = {
  primary: { color: "primary.main" },
  warning: { color: "warning.main" },
  error: { color: "error.main" },
  text: { color: "action.active", fontSize: "1.25rem" },
};

type Props = {
  title: ReactNode;
  arrow?: boolean;
  placement?: Placement;
  style?: CSSProperties;
  slotProps?: TooltipProps["slotProps"];
  variant?: Variant;
  icon?: ReactElement;
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  disableTouchListener?: boolean;
  describeChild?: boolean;
};

const InfoTooltip = ({
  title,
  arrow = true,
  placement = "right",
  style,
  slotProps,
  variant = "primary",
  icon,
  open,
  onOpen,
  onClose,
  disableTouchListener,
  describeChild,
}: Props) => {
  const resolvedIcon = icon ?? (
    <InfoOutlinedIcon sx={{ height: "20px", width: "20px" }} />
  );
  const styledIcon = cloneElement(resolvedIcon, {
    sx: [resolvedIcon.props.sx, variantSx[variant]],
  });

  return (
    <Tooltip
      style={style}
      slotProps={slotProps}
      title={title}
      placement={placement}
      arrow={arrow}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      disableTouchListener={disableTouchListener}
      describeChild={describeChild}
    >
      {styledIcon}
    </Tooltip>
  );
};

export default InfoTooltip;
